import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const MutfakDolabi = lazy(() => import('../pages/mutfak-dolabi/page'));
const TezgahCesitleri = lazy(() => import('../pages/tezgah-cesitleri/page'));
const Yukluk = lazy(() => import('../pages/yukluk/page'));
const Gardirop = lazy(() => import('../pages/gardirop/page'));
const Vestiyer = lazy(() => import('../pages/vestiyer/page'));
const GiyinmeOdasi = lazy(() => import('../pages/giyinme-odasi/page'));
const YatakOdasiTakimi = lazy(() => import('../pages/yatak-odasi-takimi/page'));
const RafSistemleri = lazy(() => import('../pages/raf-sistemleri/page'));
const ProjeTasarim = lazy(() => import('../pages/proje-tasarim/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/mutfak-dolabi',
    element: <MutfakDolabi />,
  },
  {
    path: '/tezgah-cesitleri',
    element: <TezgahCesitleri />,
  },
  {
    path: '/yukluk',
    element: <Yukluk />,
  },
  {
    path: '/gardirop',
    element: <Gardirop />,
  },
  {
    path: '/vestiyer',
    element: <Vestiyer />,
  },
  {
    path: '/giyinme-odasi',
    element: <GiyinmeOdasi />,
  },
  {
    path: '/yatak-odasi-takimi',
    element: <YatakOdasiTakimi />,
  },
  {
    path: '/raf-sistemleri',
    element: <RafSistemleri />,
  },
  {
    path: '/proje-tasarim',
    element: <ProjeTasarim />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
